import { useCallback, useState } from 'react';
import { CareTeamSlaFirstPage } from './CareTeamSlaFirstPage';
import { CareTeamSlaSecondPage } from './CareTeamSlaSecondPage';
import { useNavigate } from 'react-router-dom';
import { useAcceptCareTeamSla } from '../hooks/store/useCareTeamSla';
import { messageNavigationState } from '../../container/MessageContainerNavigationState';
import { Routes } from '@xolv-mybrightlink/common';

export const CareTeamSla = () => {
  const [page, setPage] = useState<'first' | 'second'>('first');
  const navigate = useNavigate();
  const goHome = useCallback(() => {
    navigate(messageNavigationState.collapsedPath ?? Routes.authenticated);
  }, [navigate]);
  const acceptSla = useAcceptCareTeamSla();
  const goToSecondPage = () => {
    setPage('second');
  };
  const goBackToFirstPage = () => {
    setPage('first');
  };
  const openMessaging = async () => {
    await acceptSla();
    navigate(Routes.messages.index);
  };

  if (page === 'first') {
    return (
      <CareTeamSlaFirstPage onLater={goHome} onContinue={goToSecondPage} />
    );
  }
  return (
    <CareTeamSlaSecondPage
      onBack={goBackToFirstPage}
      onLater={goHome}
      onAccept={openMessaging}
    />
  );
};
